const api = {
    sendMessageWithoutLogin: 'api/parent/notice/sendMessageWithoutLogin',   //发送验证码
    validMessageWithoutLogin: 'api/parent/notice/validMessageWithoutLogin',   //校验验证码
    getAuthorizeUrl: 'api/parent/third/getAuthorizeUrl',   //获取授权地址
    register: 'api/parent/register/register',   //微信授权注册
    modifyPhone: 'api/parent/register/modifyPhone',   //修改注册手机号
    getSchoolDetail: 'api/parent/school/schoolDetail',   //获取学校详情


    getStudentAccount: 'api/account/student/getStudentAccount',   //账户信息首页
    queryStudentAccountList: 'api/account/student/queryStudentAccountList',   //学生账户列表
    switchStudentAccount: 'api/account/student/switchStudentAccount',   //切换当前账户
    addStudentAccount: 'api/account/student/addStudentAccount',   //添加账户

    getBillList: 'api/account/student/getBillList',   //账单列表
    getMonthBillDetail: 'api/account/student/getMonthBillDetail',   //月账单列表
    getBillTypeList: 'api/account/student/getBillTypeList',   //账单列表筛选类型
    tradeDetail: 'api/parent/trade/tradeDetail',   //账单详情


    queryRechargeMinAmount: 'api/account/student/recharge/queryRechargeMinAmount',   //获取最小充值金额
    getWxJsApiSign: 'api/account/student/recharge/getWxJsApiSign',   //充值第一步
    doRecharge: 'api/account/student/recharge/doRecharge',   //充值第二步
    queryRechargeTitle: 'api/account/student/recharge/queryRechargeTitle',   //说明

    getStuRetryOrders: 'api/parent/trade/retryOrders',
    getStuUnpayOrderDetail: 'api/parent/trade/unpayOrderDetail'
}
module.exports = {
    api
};



// WEBPACK FOOTER //
// ./src/store/interfaceApi/api.js